import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appFormatCreditCard]',
    standalone: false
})
export class FormatCreditCardDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ''); // Remove all non-numeric characters
    
    // Add slash after every four digits
    value = value.match(/.{1,4}/g)?.join('-') || value;

    input.value = value;
  }

}
